import React from 'react';
export function PrivacyContent() {
  return <div className="space-y-4 text-sm md:text-base" data-id="element-112">
      <p data-id="element-113">
        <strong data-id="element-114">Last Updated: {new Date().toLocaleDateString()}</strong>
      </p>

      <h3 data-id="element-115">1. Introduction</h3>
      <p data-id="element-116">
        Welcome to No-Fall Confidence. We respect your privacy and are committed
        to protecting your personal data. This privacy policy will inform you as
        to how we look after your personal data when you visit our website and
        tell you about your privacy rights and how the law protects you.
      </p>

      <h3 data-id="element-117">2. Information We Collect</h3>
      <p data-id="element-118">
        We may collect, use, store and transfer different kinds of personal data
        about you which we have grouped together follows:
      </p>
      <ul className="list-disc pl-5 space-y-1" data-id="element-119">
        <li data-id="element-120">
          <strong data-id="element-121">Identity Data:</strong> includes first name, last name,
          username or similar identifier.
        </li>
        <li data-id="element-122">
          <strong data-id="element-123">Contact Data:</strong> includes email address and telephone
          number.
        </li>
        <li data-id="element-124">
          <strong data-id="element-125">Transaction Data:</strong> includes details about payments to
          and from you and other details of products and services you have
          purchased from us.
        </li>
        <li data-id="element-126">
          <strong data-id="element-127">Technical Data:</strong> includes internet protocol (IP)
          address, your login data, browser type and version, time zone setting
          and location, browser plug-in types and versions, operating system and
          platform and other technology on the devices you use to access this
          website.
        </li>
      </ul>

      <h3 data-id="element-128">3. How We Use Your Personal Data</h3>
      <p data-id="element-129">
        We will only use your personal data when the law allows us to. Most
        commonly, we will use your personal data in the following circumstances:
      </p>
      <ul className="list-disc pl-5 space-y-1" data-id="element-130">
        <li data-id="element-131">
          Where we need to perform the contract we are about to enter into or
          have entered into with you.
        </li>
        <li data-id="element-132">
          Where it is necessary for our legitimate interests (or those of a
          third party) and your interests and fundamental rights do not override
          those interests.
        </li>
        <li data-id="element-133">Where we need to comply with a legal or regulatory obligation.</li>
      </ul>

      <h3 data-id="element-134">4. Data Security</h3>
      <p data-id="element-135">
        We have put in place appropriate security measures to prevent your
        personal data from being accidentally lost, used or accessed in an
        unauthorized way, altered or disclosed. In addition, we limit access to
        your personal data to those employees, agents, contractors and other
        third parties who have a business need to know.
      </p>

      <h3 data-id="element-136">5. Your Legal Rights</h3>
      <p data-id="element-137">
        Under certain circumstances, you have rights under data protection laws
        in relation to your personal data, including the right to request
        access, correction, erasure, restriction, transfer, to object to
        processing, to portability of data and (where the lawful ground of
        processing is consent) to withdraw consent.
      </p>

      <h3 data-id="element-138">6. Contact Us</h3>
      <p data-id="element-139">
        If you have any questions about this privacy policy or our privacy
        practices, please contact us via the support email provided in your
        purchase confirmation.
      </p>
    </div>;
}